import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../app/store';
import { updateRegistration } from '../../../../services/RegistrationService/registrationSlice/';

const EmailEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const contactInfo = useAppSelector(state => state.registration.currentRegistration?.contactInfo) || {};
  const value = contactInfo.email || '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateRegistration({
      contactInfo: {
        ...contactInfo,
        email: e.target.value,
      },
    }));
  };

  return (
    <TextField
      type="email"
      value={value}
      onChange={handleChange}
      size="small"
      label="Email Address"
    />
  );
};

export default EmailEdit;
